import type {
  AccessibleChatbotDTO,
  Chatbot,
  ChatbotConversation,
  ChatbotMembership,
  ChatbotMessage,
  ChatbotTrainingExample,
  Role,
} from '@liks/backend-svc-api/esm/models/index';

export type {
  AccessibleChatbotDTO,
  Chatbot,
  ChatbotConversation,
  ChatbotMembership,
  ChatbotMessage,
  ChatbotTrainingExample,
};

/** Alias for OpenAPI chatbot membership Role. */
export type ChatbotMemberRole = Role;

export type ChatbotWithIdentity = Chatbot & {
  id: string;
  name: string;
};

export type AccessibleChatbotWithIdentity = {
  chatbot: ChatbotWithIdentity;
  role: ChatbotMemberRole;
};

export type ChatbotConversationWithIdentity = ChatbotConversation & {
  id: string;
};

export type ChatbotMessageWithIdentity = ChatbotMessage & {
  id: string;
};

export type ChatbotTrainingExampleWithIdentity = ChatbotTrainingExample & {
  id: string;
  question: string;
  answer: string;
};

export type ChatbotMembershipWithIdentity = ChatbotMembership & {
  id: string;
  userId: string;
};

/** Alias for OpenAPI ChatbotPlacement enum. */
export type { ChatbotPlacement } from '@liks/backend-svc-api/esm/models/index';

export const DEFAULT_CHATBOT_PRIMARY_COLOR = '#2563eb';

/** Partial chatbot config fields accepted by update. */
export type ChatbotConfigUpdate = {
  name?: string | null;
  displayName?: string | null;
  isPublic?: boolean | null;
  welcomeMessage?: string | null;
  systemPrompt?: string | null;
  primaryColor?: string | null;
  placement?: string | null;
  corsAllowCredentials?: boolean | null;
  corsAllowedOrigins?: string[];
  maxResults?: number | null;
  minScore?: number | null;
};
